import { useState } from "react";
import { AuthImg } from "@/components/AuthImg";
import { PhotoLightbox } from "@/components/PhotoLightbox";

// Shared thumbnail strip: renders auth-protected thumbnails and opens the shared
// lightbox (full-size + paging) on tap. Filters archived photos. Paging in the
// lightbox covers ALL photos, not just the capped strip.
export function PhotoThumbs({ photos, max = 12, size = "w-12 h-12", testidPrefix = "thumbs", label = "photo",
                              fixScope, fixRecordId, onFixed }) {
  const [idx, setIdx] = useState(null);
  const shots = (photos || []).filter((p) => p && p.file_id && !p.is_archived);
  if (!shots.length) return null;
  const shown = shots.slice(0, max);
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={`${testidPrefix}-root`}>
      {shown.map((p, i) => (
        <button
          key={`${p.file_id}-${i}`}
          type="button"
          onClick={() => setIdx(i)}
          data-testid={`${testidPrefix}-thumb`}
          className="rounded-md overflow-hidden border border-slate-200 hover:ring-2 hover:ring-[#B01E28]/40 transition-shadow"
          title="View full size"
        >
          <AuthImg fileId={p.file_id} thumb className={`${size} object-cover`} alt={`${label} ${i + 1}`} />
        </button>
      ))}
      {shots.length > max && <span className="text-[11px] text-slate-400 self-center">+{shots.length - max} more</span>}
      <PhotoLightbox photos={shots} index={idx} onClose={() => setIdx(null)} onIndex={setIdx} testidPrefix={`${testidPrefix}-lightbox`}
        fixScope={fixScope} fixRecordId={fixRecordId} onFixed={onFixed} />
    </div>
  );
}
